import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export type HeaderProps = React.PropsWithChildren<{ breadcrumbs?: React.ReactNode }>;

const header = css`
  margin-bottom: ${theme.spacing(4)};
  grid-area: header;
  @media (max-width: ${breakpoints.xsmall.max}px) {
    margin-bottom: 0;

    h1 {
      font-size: ${theme.fontSize(24)};
    }
  }
`;

export function Header({ children }: HeaderProps) {
  return (
    <header css={header} className='page-header'>
      {children}
    </header>
  );
}
